import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid o-grid-12"
}
const _hoisted_2 = {
  key: 0,
  class: "o-grid-12"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "o-grid-12"
}
const _hoisted_5 = { class: "o-grid o-grid-12 -repeater-item o-form__repeater__item" }
const _hoisted_6 = { class: "o-grid-12 -repeater-item__header o-form__repeater__header" }
const _hoisted_7 = {
  class: "o-title-4",
  style: {"margin-bottom":"0"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "o-grid-12"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
        ($props.sectionTitle && String($props.sectionTitle).trim()!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", {
                class: "o-title-3",
                innerHTML: $props.sectionTitle
              }, null, 8 /* PROPS */, _hoisted_3)
            ]))
          : _createCommentVNode("v-if", true),
        ($props.field.groupIsRepeater && $props.field.groupIsRepeater === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.fieldsList, (fieldsList, ri) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h4", _hoisted_7, _toDisplayString($props.field.repeaterItemsLabel) + " " + _toDisplayString(ri+1), 1 /* TEXT */),
                    ($props.field.fieldsList.length > $options.repeaterMinlength)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "o-form__repeater__header__button",
                          onClick: $event => ($props.field.fieldsList.splice(ri, 1))
                        }, [
                          _createVNode(_component_svgIco, {
                            icon: "bin",
                            class: "o-form__repeater__header__button__icon"
                          })
                        ], 8 /* PROPS */, _hoisted_8))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldsList, (fieldd, fi) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(fieldd.inputType), {
                      key: fieldd.id + '-' +fieldd.repeaterIndex,
                      field: fieldd,
                      disabledIDs: $props.disabledIDs,
                      class: "o-form__item__wrap",
                      repeaterIndex: fieldd.repeaterIndex
                    }, null, 8 /* PROPS */, ["field", "disabledIDs", "repeaterIndex"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($props.field.groupIsRepeater && $props.field.groupIsRepeater === true && $options.repeaterMinlength != $options.repeaterMaxlength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "o-button -button-md",
                type: "button",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.addItem && $options.addItem(...args))),
                disabled: ($options.repeaterMaxlength && $options.repeaterMaxlength > 0 && $options.repeaterMaxlength < $props.field.fieldsList.length + 1) ? 'disabled' : false
              }, [
                _createVNode(_component_svgIco, {
                  icon: "add",
                  class: "o-button__icon"
                }),
                _createElementVNode("span", {
                  innerHTML: $props.field.repeaterButtonLabel
                }, null, 8 /* PROPS */, _hoisted_11)
              ], 8 /* PROPS */, _hoisted_10)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList($props.field.fieldsList, (fieldd, fi) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(fieldd.inputType), {
                key: fieldd.id,
                field: fieldd,
                disabledIDs: $props.disabledIDs,
                class: "o-form__item__wrap"
              }, null, 8 /* PROPS */, ["field", "disabledIDs"]))
            }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}